<template>
  <v-container fluid fill-height>
    <v-row class="ma-0">
      <v-col cols="12" sm="8" offset-sm="2" md="6" offset-md="3" xl="4" offset-xl="4" align="center">
        <v-card>
          <v-row class="error mb-5" v-if="error">
            <v-col>
              <app-alert-error @dismissed="onDismiss" :text="error.message"></app-alert-error>
            </v-col>
          </v-row>
        </v-card>

        <v-card>
          <v-row class="primary">
            <v-col class="pb-0">
              <a @click="goToPath('/')">
                <v-img height="auto" width="100" src="@/assets/zf-logo-white-cirle.png"/>
              </a>
            </v-col>
          </v-row>

          <v-row class="primary">
            <v-col>
              <h2 class="white--text ">Set a new password</h2>
            </v-col>
          </v-row>

          <v-row class="white">
            <v-col>
                <v-form lazy-validation v-model="valid" ref="form" @submit.prevent="onSetNewPassword">
                  <v-row>
                    <v-col>
                      <v-text-field color="farmer_green" prepend-icon="lock" :append-icon="show ? 'visibility_off' : 'visibility'" name="password" label="Password" :rules="fieldRules('Password', 20)" :type="show ? 'text' : 'password'" v-model="password" @click:append="show = !show" required></v-text-field>
                      <v-text-field color="farmer_green" prepend-icon="lock" :append-icon="show ? 'visibility_off' : 'visibility'" name="confirPassword" label="Confirm Password" :rules="comparePasswords" :type="show ? 'text' : 'password'" v-model="confirmPassword" @click:append="show = !show" required></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row no-gutters>
                    <v-col>
                      <v-card flat>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn class="pa-5" color="farmer_green" dark type="submit" :disabled="isLoading" :loading="isLoading" @click="loader = 'loading'">Submit</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-form>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      isLoading: false,
      valid: true,
      password: '',
      confirmPassword: '',
      show: false
    }
  },
  computed: {
    ...mapGetters(['error']),
    fieldRules() {
      return (fieldName, maxChar) => [
        v => (!!v && !!v.trim()) || `${fieldName} is required`,
        v =>
          (v && v.length <= maxChar) ||
          `${fieldName} must be less than ${maxChar} characters`
      ]
    },
    comparePasswords() {
      return [p => p === this.password || 'Passwords do not match']
    }
  },
  methods: {
    onSetNewPassword() {
      this.isLoading = true
      this.$store.dispatch('setNewPassword', {
        newPassword: this.password
      }).catch((err) => {
        this.$store.commit('setError', err)
        this.isLoading = false
      })
    }
  }
}
</script>
